import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d17a774a-7143-4dab-9b1d-179c443c81ce";
export const REGISTER_URL = "https://a.ntrk2.com/0f2cf37d-607a-432a-bd81-9ec58d7c5908";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://win268.kzw2a.com/download?openExternalBrowser=1&id=lwmxtap3co8qpcg";

export * from "./codes";
export * from "./context";
